import _mergeJSXProps from './node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.mjs';

var BagMoneyBgIcon = {
  name: 'BagMoneyBgIcon',
  props: {},
  functional: true,
  render(h, ctx) {
    const attrs = ctx.data.attrs || {};
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      "attrs": {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 148 148"
      },
      "class": "c-ficon c-ficon--bag-money-bg"
    }, ctx.data]), [h("path", {
      "attrs": {
        "d": "m11 42.5 12.4 58H138L11 42.5Z",
        "fill": "#FFD9B2"
      }
    }), h("path", {
      "attrs": {
        "d": "m62 97.6.8 14.2c.1 1.7 2.9 1.7 2.8 0l-.8-14.2c0-1.8-2.8-1.8-2.7 0Zm15.3-.6c.4 4.7.6 9.4.8 14.1 0 1.8 2.7 1.8 2.7 0-.1-4.7-.4-9.4-.7-14-.1-1.8-2.9-1.8-2.8 0Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m36.2 97 5.1-20.4 1.9-11 2.3-18.4 5.5-4 52.6-.7-4.3 22-2 9.8s.3 14-1 20.6c1.3-.2-20.3 3.2-31 3.3-10.7 0-29.1-1.3-29.1-1.3Z",
        "fill": "#fff"
      }
    }), h("path", {
      "attrs": {
        "d": "m52 44.2.5 17.4L50.8 72 43.3 98l-6.3-3.2s4.9-21.4 5-23.4l3.3-24.1 6.8-3Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "M36.9 97c1.7.1 3.3 1 5 1.6 1.8.5 3.6.4 5.5.5H59A264.8 264.8 0 0 0 96 95.6c1.4-.2.8-2.4-.6-2.2a263.4 263.4 0 0 1-46.7 3.4c-2.1 0-4.2.2-6.3-.4-1.8-.6-3.6-1.5-5.6-1.8-1.4-.2-1.4 2.1 0 2.3Zm8.6-48.3 6-4.5c1.3-.8.1-2.8-1-2l-6.2 4.5c-1.1.9 0 2.8 1.2 2Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m51.2 44.1 28.5-.4c1.4 0 1.4-2.3 0-2.3l-28.5.5c-1.5 0-1.5 2.3 0 2.2Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M80 43.5c7.8-.5 15.7 0 23.6.1 1.5 0 1.5-2.2 0-2.2-7.9-.2-15.8-.7-23.6-.1-1.5 0-1.5 2.3 0 2.2Zm17 30c-.1 7-.8 14-1.7 21-.2 1.5 2.1 1.5 2.3 0 .9-7 1.6-14 1.6-21 0-1.5-2.3-1.5-2.3 0ZM50.2 43.2c.3 5 .5 10 .5 15 0 1.4 2.3 1.4 2.3 0 0-5-.2-10-.6-15 0-1.4-2.3-1.5-2.2 0ZM45.2 86A80 80 0 0 1 42 97.4c-.5 1.4 1.7 2 2.2.6 1.3-3.7 2.3-7.5 3-11.4.3-1.4-1.9-2-2.1-.5Zm40.3-37-.1.5a.7.7 0 0 0 .5.8.7.7 0 0 0 .8-.5l.2-.4a.7.7 0 0 0-.5-.9.7.7 0 0 0-.9.5Zm-15.3.9.2.3a.7.7 0 0 0 1.2-.2.8.8 0 0 0 0-.5l-.2-.3a.7.7 0 0 0-1.2.2.8.8 0 0 0 0 .5ZM43 69.3c.7-3.3.9-6.6 1.3-9.8.5-4 1-7.8 1.3-11.8 0-1.3-2-1.3-2.1 0a151 151 0 0 1-1.2 11.4c-.4 3.2-.6 6.5-1.3 9.6-.2 1.3 1.7 1.8 2 .5Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M37.4 95.6c1.2-4 2.3-8.2 3.3-12.4 1-4.5 1.7-9.1 2.4-13.7.2-1.3-1.8-1.9-2-.5-.7 4.5-1.4 9.1-2.4 13.7-1 4.1-2 8.3-3.2 12.4-.4 1.3 1.6 1.8 2 .5ZM51 60.7l-1.3 11.7c0 1.3 2 1.3 2.1 0L53 60.7c.2-1.3-1.9-1.2-2 0Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M85.6 78.4a151.8 151.8 0 0 0-3.7-4.5l-.4-4.2a.6.6 0 0 0-.4-.5l-1-.4a.6.6 0 0 0-.9.5v1.5l-.6-.6c-.6-.8-1.3-1.6-2.1-2.3-1-.7-2-.7-3 0A36 36 0 0 0 62 79a.6.6 0 0 0 .2 1c1 .6 2.1.9 3.2.8-.3 2.3-.5 4.6-.3 6.8.2 1.4 1.2 1.4 2.3 1.3H69c0-1.8.2-3.6.5-5.5a2.2 2.2 0 0 1-.3 0c-.7-.3-1-1-1.1-1.7v-2.1l.1-.3.4-2.5c0-.6 1-.4.9.2l-.2 1-.2 1.2v.5l-.1.5v.2l.1.1a.7.7 0 0 0 .3.2l.3.1h.3l.5-4c.1-.7 1-.5 1 0a79.7 79.7 0 0 0-.6 3.7v.3a4 4 0 0 0 1-.3l.5-2.9.2-1c.1-.5 1-.3.9.2l-.3 1.6-.5 2.6a6 6 0 0 1-.6 1.8 1 1 0 0 1-1 .5l-.4.1-.1 5.5h1.5l4-.1.3-3h-1.3a.7.7 0 0 1-.4-.4.5.5 0 0 1-.2-.4 16.1 16.1 0 0 1 3.3-8.7c0-.5.8-.6.8 0a99.3 99.3 0 0 1-.3 12.2c.9 0 1.8-.3 2.4-.7 1-.7 1.1-1.9 1.2-3v-.4l.4-4.4c1 0 2-.3 2.9-.7a.6.6 0 0 0 .3-1Zm-22.3.9.1-.1v.1Zm7-4.8Zm7.8-3 1.4 1.6-.3-.4-1.1-1.2Zm2.3.7v.1-.2.1Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "M102.4 42.2 99 58.4c-1 4.9-.9 10-1.9 14.8-.3 1.4 1.9 2 2.2.6 1-4.9 1-9.9 1.9-14.8l3.3-16.2c.3-1.4-2-2-2.2-.6ZM62.9 97l.3-3.3c.1-1.2-1.7-1.2-1.8 0L61 97c-.1 1.2 1.7 1.2 1.8 0Zm-3 0 .1-.7c0-.5-.4-.9-1-.9a1 1 0 0 0-.8 1v.6c0 .5.3 1 .8 1a1 1 0 0 0 1-1Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M68.3 58.6c.7-.7 1.2-1.9.3-2.7-1-.8-2.2 0-2.7.9a.7.7 0 0 0 1 .8h.1a.7.7 0 0 0 1.2 0 .4.4 0 0 1 .1 0h-1 .1l-.2-.7.2-.2.3-.2.5.1c-.9-.4-1.5.7-.8 1.2.8.4 1.5-.6 1-1.2-.3-.3-.7-.2-1 0l-.4.4h1.2a1.5 1.5 0 0 0-2.2-.4l1 .9.4-.5h.3v-.1c.1.2-.2.6-.3.7-.6.7.3 1.7 1 1Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "M64.3 55.6a9.2 9.2 0 0 0 7.3 5.4c.9.1.9-1.3 0-1.4a7.8 7.8 0 0 1-6.1-4.7c-.4-.8-1.5 0-1.2.7Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "M47 55.1c2.4 5 7.3 9 13 9.9 3 .5 6.3 0 9.2-1.2 1.4-.6 2.6-1.4 3.7-2.4.9-.9 1.7-1.9 2.4-3l1.2-1.6.3-.4.2-.2c0-.1-.2.2 0 0l.6-.8a12.2 12.2 0 0 1 1.6-1.4 7.3 7.3 0 0 1 1.2-.8l-1.3-1.8-.5.5c.3-.1 0 0 0 0l-.3.2c-.2.1.1 0 0 0H78a.7.7 0 0 1-.2.1h-.2l.8 2c-.2.2 0 0 0 0l.2-.1.2-.1c.1-.1.1-.1 0 0a3.5 3.5 0 0 1 .6-.2h1.2c.3.2-.2 0 0 .1l-.2-1.8v.1l-.3.2-.3.1s-.1 0 0 0h-.1a1.7 1.7 0 0 1-.6.2c.3 0 0 0 0 0h-.4L79 55a6.6 6.6 0 0 1 1.4 0h.5l.8.2-.2-2-.7.3-.1.1a2.8 2.8 0 0 1-.6.2H79.3s-.2 0 0 0h-.2L79 56l1.3.2v-2.3H78.6c-.2 0 .1 0 0 0a11.9 11.9 0 0 1-1.8-.5 1.1 1.1 0 0 0-1.4.8c-.2.6.2 1.2.8 1.4 1.3.5 2.6.7 4 .6.6 0 1.2-.5 1.2-1.1 0-.7-.5-1.1-1.2-1.2l-1.3-.1c-.6-.1-1 .5-1.1 1 0 .5.2 1 .8 1.2a5 5 0 0 0 4-.9c.4-.3.6-.6.6-1.1a1.1 1.1 0 0 0-.8-1 9.5 9.5 0 0 0-4-.2c-.6 0-1 .7-.9 1.2.1.6.6 1 1.2 1a5 5 0 0 0 3.4-1.2c.5-.5.4-1.5-.2-1.8a4.7 4.7 0 0 0-5 .6c-.4.3-.5.9-.3 1.2.2.5.6.7 1 .7a4.2 4.2 0 0 0 3.1-1.4c.4-.4.4-1 0-1.5-.3-.5-.9-.5-1.4-.3-2.2 1-3.7 3-5.1 5l-1 1.4-.3.3-.2.2-.5.7L71 60l-.4.3c-.2.2.2-.1 0 0l-.3.2a13.3 13.3 0 0 1-1.8 1l-.2.2H68c.2 0-.1.1-.1.1l-.3.1a15.2 15.2 0 0 1-3.2.8s-.2 0 0 0h-.3a17 17 0 0 1-3.3 0h-.2c-.3 0 .3 0 0 0a15.3 15.3 0 0 1-3.8-1c.3.1 0 0 0 0l-.2-.1-1-.4-1.5-1-.4-.3s-.3-.2 0 0l-.3-.2A17.3 17.3 0 0 1 51 57s-.2-.3 0 0l-.2-.3A17.8 17.8 0 0 1 49 54c-.3-.5-1.1-.7-1.6-.4a1.2 1.2 0 0 0-.4 1.6Zm53.5 4.9c.2.2-.1-.2 0 0l.1.2.2.3c0 .2-.1-.2 0-.1v.2a17.5 17.5 0 0 1 .9 3.3v.6l.1.3c0 .1 0 .3 0 0v.2a20.6 20.6 0 0 1 .1 4v.4a7.4 7.4 0 0 1-.3 1.1v.2l-.1.2v-.1l-.3.5v.1c-.2.2.1-.2 0 0l-.4.4.1-.1h-.2a1.4 1.4 0 0 0 0 .1s.1 0 0 0h-.1l-.4.1h.1H98.2a4.6 4.6 0 0 1-.7-.3c.2.2 0 0-.1 0a5 5 0 0 1-.7-.4 2.1 2.1 0 0 0 0-.1 9.4 9.4 0 0 1-1.3-1.3l-.2-.1c0-.1 0-.1 0 0v-.2l-.4-.5a9 9 0 0 1-.5-.9l-.2-.4c0 .3 0 0 0 0l-.1-.3a11.2 11.2 0 0 1-.5-2v-.2c0-.2 0 .2 0 0v-.5l-.2-1-2 .6v.1l.1.4 2.1-.9a3.2 3.2 0 0 0-1.1-1.2 1.1 1.1 0 0 0-1.2 0c-.3.2-.6.6-.7 1-.1.4 0 1 .4 1.3.5.5 1.2.4 1.7 0 .5-.5.5-1.2 0-1.7-.6-.6-1.6-.4-2.3-.1-.4.2-.7.6-.7 1.1 0 .5.3 1 .8 1.2.6.2 1.2.1 1.8-.1.6-.2 1.3-.5 1.5-1.2.4-.8-.1-1.6-.8-1.9a2.6 2.6 0 0 0-2 .1 2 2 0 0 0-1 .6c-.4.5-.4 1.1 0 1.6.6.8 1.7.7 2.4.2.5-.3.8-1 .4-1.6a1.2 1.2 0 0 0-1.5-.4c-.6.3-1 1-.7 1.6.3.5.8.8 1.3.8a1.2 1.2 0 1 0 0-2.4 1.1 1.1 0 1 0 0 2.3l-.6-.2-.3-.4-.1-.8.8-.8.6.1.4.4v1.1l-.3.3-1.1-2s-.4.2-.1.1c-.2 0-.1 0 0 0l.5.2.3.5v.3l-.2.6c0-.1 0-.1 0 0a.4.4 0 0 1-.2.1h.2c.2-.2-.2 0 0 0l.3-.1h-.1c.4 0 0 0 0 0a1 1 0 0 1-.2-1.2v-.1l.2-.1h-.2c-.2.2 0 0 0 .1l-.3.1h-.2s-.3 0 0 0H91l.3.2.4.4.2.5-.2.5-.3.3-.1.1h.2s.2 0 0 0c.2 0 0 0-.3-.2l-.4-.4v-1l.4-.5.5-.1.8.3c.3.6.3 1-.1 1.3h-1.2c.3.2-.1-.2 0 0l.2.2c.1.1 0-.2 0 0l.1.2c.3.5 1 .7 1.4.5.6-.2.9-.8.7-1.4a6.4 6.4 0 0 0-.4-1c-.5-1.1-2.2-.6-2.2.5 0 1.3.3 2.7.6 4 .5 1.4 1.2 2.7 2.2 3.9a7.3 7.3 0 0 0 3.6 2.4 8 8 0 0 0 2.4.3 4.3 4.3 0 0 0 2.1-.6c1.7-1 2.2-3.2 2.3-5a21.7 21.7 0 0 0-1.1-8.5c-.2-.6-.5-1.4-1-1.8-.5-.4-1.2-.5-1.6 0-.4.4-.5 1.2 0 1.6Zm-35-17.5a30 30 0 0 1-.3-5.2l-1.1 1.1a98.5 98.5 0 0 0 10.1.1h1c.1 0 1.2 0 .6-.3-.4-.2-.2 0-.2.3l.2 1.1.5 2.2c.2 1.4 2.4.8 2.2-.6l-.5-2.6-.4-1.6c-.8-1.3-2.4-.8-3.6-.8-3.3.2-6.6.1-10 0-.6-.1-1 .5-1 1-.1 2 0 4 .3 5.9.2 1.4 2.4.8 2.2-.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m90 41.4-1.8-4.7c-.6-1.4-1.8-1.3-3.2-1.2l-11.4.7c-.5 0-1.2.4-1.1 1.1l.3 4.7c.1 1.5 2.4 1.5 2.3 0l-.3-4.7-1.2 1.1L83 38l2-.1h1c.3 0 .3-.1 0-.3l.1.2c.1.7.6 1.5.8 2.2l.8 2.1c.5 1.4 2.7.8 2.2-.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m99.4 62.9.8 2.5-8 3.6-1.9.5-4.2-2.9-7.2-2.8.5-2.6 6.1-2 6.2 2.3 7.2.6.5.8Z",
        "fill": "#4CD386"
      }
    }), h("path", {
      "attrs": {
        "d": "M99 61.3h-.3a14.3 14.3 0 0 1-4.6 0c-1.8-.3-3.4-1-5-1.7l-2.9-1.1c-.8-.3-1.2 1-.3 1.3l5.2 2a15.8 15.8 0 0 0 7.3 1c.5-.1 1.2-.1 1.6-.5.6-.7-.4-1.7-1-1Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M86 58.4c-2.3.2-4.5.7-6.7 1.4a.7.7 0 0 0-.5.8c.1.4.5.6.9.5a29.6 29.6 0 0 1 6.2-1.3.7.7 0 0 0 .7-.7c0-.4-.3-.7-.7-.7Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M78.6 61a.5.5 0 0 1 0-.2c.2-.1.2-.1.1 0h-.2a.7.7 0 0 0-.2.8l.4.4h.1c0 .1 0 0-.1 0v-.5c.1 0 0 0 0 0l-.4.4a.7.7 0 0 0 .2.8V62.3a.4.4 0 0 1 0-.2l-.1.2a.8.8 0 0 0-.1.4c0 .3 0 .5.3.7.2.2.6.2.8 0a.6.6 0 0 0 0-.8v.2c0 .2-.1.2 0 .1v-.2a.7.7 0 0 0 .1-.3.8.8 0 0 0-.2-.5c.1 0 0 .1 0 0l.1.2v.1a.4.4 0 0 1-.1.2c0-.1-.1 0 0 0l.2-.2c.2-.2.3-.5.2-.8a.8.8 0 0 0-.3-.4h-.1c0-.1.1 0 0 0l.1.1V61.5a.3.3 0 0 1 0 .2h-.1.1a.8.8 0 0 0 .3-.6.6.6 0 0 0-1-.4.6.6 0 0 0-.1.4Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m78.7 64.3 3.2 1.5 3.2 1.4 3.4 1.2 1.6.6c.6.2 1.1.4 1.7.4 2.4-.3 4.6-1.5 6.7-2.6l1.6-.7.8-.4c.2-.3.2-.6 0-.9a.7.7 0 0 0-.9-.2.7.7 0 0 0-.2 1v-1h.2-.1l-.4.3-1.3.6-3 1.4-.8.4h-.1l-.3.1a12.7 12.7 0 0 1-2.3.6 1 1 0 0 1-.5 0l-1.6-.7-3.3-1.2-3.4-1.3-3.5-1.7a.7.7 0 0 0-1 .2.7.7 0 0 0 .3 1Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M79.1 60.6h.8l.3.5-.5.6h-.3l1.3.5 1.4.6 2.7 1.1 2.8 1 2.8 1c.4 0 1 .3 1.5.4a4 4 0 0 0 1.6-.4.7.7 0 0 0 .4-.8.7.7 0 0 0-.8-.5 16.5 16.5 0 0 1-1 .3 1 1 0 0 1-.1 0 3.5 3.5 0 0 1-.6-.2l-.7-.2-2.8-1-2.7-1-2.7-1-1.5-.6-.7-.3c-.3-.2-.6-.3-1-.2a.7.7 0 0 0-.4.7c0 .2.1.5.3.6.3.1.6.1.9-.1a.7.7 0 0 0 0-1 .7.7 0 0 0-1 0Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M92.6 66.1a37.3 37.3 0 0 0 6.5-2.6c.4-.2.5-.6.3-1a.7.7 0 0 0-1-.2 35.5 35.5 0 0 1-6.2 2.5c-.8.3-.5 1.6.4 1.3Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M99.5 62.2a1 1 0 0 0-.4.5c0 .3 0 .7.3.8l.2.1c.1 0 0 0 0 0a.3.3 0 0 1 0-.2v-.2l-.2.2c-.2.2-.3.4-.2.7 0 .3.3.4.5.5.1.1 0 0 0 0a.3.3 0 0 1 0-.2.8.8 0 0 0 0 .9.5.5 0 0 0 .9-.4v-.3a.5.5 0 0 0-1 .1v.4a.5.5 0 0 0 1-.5c-.1 0-.1 0 0 .1l-1 .1v.3l1-.3v.1c0 .1 0 0 0 0v-.2a.8.8 0 0 0 0-.6 1 1 0 0 0-.3-.4h-.2v-.1c-.1 0-.1 0 0 0v.5l.3-.3a.7.7 0 0 0 0-.8 1 1 0 0 0-.4-.3s.1.2.1.3c.3-.3.3-.6 0-.8a.5.5 0 0 0-.6 0ZM79 61.6v.6-.1a.3.3 0 0 0 .2.5h.2l.2-.5v-.5a.3.3 0 0 0 0-.2.3.3 0 0 0-.5 0 .3.3 0 0 0 0 .2Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m79.1 62.5.2.1.2.2c.2 0 .4.1.5.3a.3.3 0 0 0 .4-.1.3.3 0 0 0 0-.3.3.3 0 0 0-.1-.1 4.7 4.7 0 0 0-1-.6.3.3 0 0 0-.4.2.3.3 0 0 0 0 .2l.2.1ZM91.6 66a.8.8 0 0 0-.3.5v.3l.2.2v-.1a.3.3 0 0 0 0 .5l.3.2c.1 0 .3 0 .3-.2a.3.3 0 0 0-.2-.4v.4-.1a.5.5 0 0 0 .2-.3.5.5 0 0 0-.2-.4v-.1c-.1 0-.1 0 0 0 0 0-.1 0 0 0 0 0-.1 0 0 0 .2-.2.2-.4 0-.5a.3.3 0 0 0-.3 0Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m86.6 65.6 4.7 1.6s1.3 0 2-.3a5.4 5.4 0 0 1 1.7-.4s-.5 1.2-3.3 2.2c-2.8 1-1.7.8-1.7.8l-4-4 .6.1Z",
        "fill": "#C0FC7A"
      }
    }), h("path", {
      "attrs": {
        "d": "m84.8 65.1 2.3 1 1 .4 1.2.3c.4.1.5-.4.2-.6l-1.2-.2-1-.4-2.2-1c-.4-.1-.7.4-.3.5Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m94.3 67.2-3 1.3c-.3 0-.5.2-.8.3l-.2.1h.1a43 43 0 0 1-1.7-1.2l-2.3-2-.9-.9c-.3-.3-1 .3-.5.6l2 1.9 1 1 1.5 1 .7.5.7-.3a43 43 0 0 1 3.6-1.5c.5-.2.3-1-.2-.8Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M92 66.9h-.2c-.1 0-.1 0 0 0H90.8a.3.3 0 0 0-.3.3l.1.2h.2l.7.1c.3 0 .5 0 .8-.2a.3.3 0 0 0 0-.4.3.3 0 0 0-.3 0Zm-3.3-5.6c-.3-.5-.9-.5-1.4-.3-.4.1-.9.5-1.4.4v.6c.3 0 .5.3.8.5.3.3.7.5 1 .5a.3.3 0 0 0 .4-.3.3.3 0 0 0-.3-.3c-.4 0-.7-.3-1-.5a1.8 1.8 0 0 0-1-.5.3.3 0 0 0 0 .6h.8l.6-.4c.3-.1.8-.4 1 0 .2.3.7 0 .5-.3Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m87.8 61.5-1.3-.6a.3.3 0 1 0-.3.5l1.3.6a.3.3 0 0 0 .3-.5Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M85.8 59.6c.3 0 6.7 2.7 9.8 2.6 3-.1 3.2.5 3.2.5l-6.9 3S80 61.4 80 61c0-.5 2.6-1.5 2.6-1.5l2.8-.8.5.8Z",
        "fill": "#4CD386"
      }
    }), h("path", {
      "attrs": {
        "d": "M99 61.3h-.3a14.3 14.3 0 0 1-4.6 0c-1.8-.3-3.4-1-5-1.7l-2.9-1.1c-.8-.3-1.2 1-.3 1.3l5.2 2a15.8 15.8 0 0 0 7.3 1c.5-.1 1.2-.1 1.6-.5.6-.7-.4-1.7-1-1Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M86 58.4c-2.4.2-4.7.9-7 1.6a.7.7 0 0 0-.4.8c0 .4.4.6.8.5 2.1-.7 4.3-1.3 6.5-1.5a.7.7 0 0 0 .7-.7c0-.4-.3-.7-.7-.7Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M79 61.5h.2s-.1 0 0 0l.2.1.6.3 1.1.5 3 1.2 3 1 3 1.1.8.3.8.3c.6 0 1.3-.2 1.8-.4a.7.7 0 0 0 .5-.8.7.7 0 0 0-.9-.5 5.8 5.8 0 0 1-1.2.3l-1.4-.5-3-1-2.8-1-2.9-1.2-.4-.2h-.1l-.6-.3-1.3-.5c-.3-.2-.8.1-.8.4a.7.7 0 0 0 .4.9Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M92.6 66.1a37.3 37.3 0 0 0 6.5-2.6c.4-.2.5-.6.3-1a.7.7 0 0 0-1-.2 35.5 35.5 0 0 1-6.2 2.5c-.8.3-.5 1.6.4 1.3Zm-3.9-4.8c-.3-.5-.9-.5-1.4-.3-.4.1-.9.5-1.4.4v.6c.3 0 .5.3.8.5.3.3.7.5 1 .5a.3.3 0 0 0 .4-.3.3.3 0 0 0-.3-.3c-.4 0-.7-.3-1-.5a1.8 1.8 0 0 0-1-.5.3.3 0 0 0 0 .6h.8l.6-.4c.3-.1.8-.4 1 0 .2.3.7 0 .5-.3Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m87.8 61.5-1.3-.6a.3.3 0 1 0-.3.5l1.3.6a.3.3 0 0 0 .3-.5Z",
        "fill": "#4C4C4C"
      }
    })]);
  }
};

export { BagMoneyBgIcon as default };
